// extracted by css-extract-rspack-plugin
export default {"wrapper_override":"oM2i4","wrapperOverride":"oM2i4","#":"JTpii","content":"L1rrt","img":"_CNM6","subtitle":"Vinb9","radio_group":"TfWxc","radioGroup":"TfWxc"};